import { CurrencyFormat } from "../../../../components/helpers"

export default function convertGadaiDetail(data, additionalData) {
    let convertedGadaiDetail = {}

    let bill = {
        loanAmount: `Rp ${CurrencyFormat(data?.loan_amount)}`,
        lateCharge: `Rp ${CurrencyFormat(data?.late_charge)}`,
        savingLateCharge: `Rp ${CurrencyFormat(data?.saving_late_charge)}`,
        total: `Rp ${CurrencyFormat(data?.loan_amount + data?.late_charge + data?.saving_late_charge)}`,
        totalWithVoucher: `Rp ${CurrencyFormat(data?.loan_amount + data?.late_charge + data?.saving_late_charge - additionalData?.voucher[0]?.voucher_amount)}`
    }
    convertedGadaiDetail = { bill, additionalData }
    return convertedGadaiDetail
}